// extracted by css-extract-rspack-plugin
export default {"folder-description":"P5E97k","folderDescription":"P5E97k","start-infscroll-button":"pkN22v","startInfscrollButton":"pkN22v","hidden":"cUy7WI"};